import UIAssetKeys from "../UIAssetKeys";

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 */
export function covertCreateJsAnimationsToPhaser(texture)
{
    updatePivot(texture.get(UIAssetKeys._animations_bird_fly_0), PICNIC_BASKET_DATA.frames[10]);
    updatePivot(texture.get(UIAssetKeys._animations_bird_fly_3), PICNIC_BASKET_DATA.frames[11]);
    updatePivot(texture.get(UIAssetKeys._animations_bird_idle_0), PICNIC_BASKET_DATA.frames[9]);
    updatePivot(texture.get(UIAssetKeys._animations_eye_blink_1), PICNIC_BASKET_DATA.frames[13]);
    updatePivot(texture.get(UIAssetKeys._animations_eye_idle_0), PICNIC_BASKET_DATA.frames[12]);
}

/**
 * 
 * @param {Phaser.Textures.Frame} frame 
 * @param {number[]} frameData
 */
function updatePivot(frame, frameData)
{
    frame.customPivot = true;
    frame.pivotX = frameData[5] / frameData[2];
    frame.pivotY = frameData[6] / frameData[3];
}

// original frame data from CreateJS (slightly altered due to updated graphics)
const PICNIC_BASKET_DATA = {
    frames: [
        [0, 0, 221, 175, 0, -14, 0],
        [221, 0, 221, 168, 0, -14, -7],
        [442, 0, 222, 160, 0, -14, -15],
        [664, 0, 230, 152, 0, -11, -23],
        [0, 175, 236, 143, 0, -8, -32],
        [236, 175, 242, 134, 0, -5, -41],
        [662, 175, 246, 126, 0, -3, -49],
        [250, 318, 248, 123, 0, -2, -52],
        [0, 318, 250, 123, 0, -1, -52],
        [478, 175, 184, 127, 0, 0, -1],
        [681, 318, 183, 96, 0, 0, -1],
        [498, 318, 183, 97, 0, 0, 25],
        [894, 0, 6, 6, 0, 0, 0],
        [900, 0, 5, 1, 0, 0, -2]
    ],
}